import { SelectOption } from '@globaleris/ui.library'
import { EnumCommodity, EnumTipoSujeto } from '../../../api'
import {
  apiDeactivateUsuarioAtlas,
  apiGetAtlasAccessDetail,
  apiGetAtlasAccessKpis,
  apiGetAtlasAccessTable,
  apiGetAtlasSuperUsers,
  apiSearchAtlasAccess,
  apiSearchAtlasUsers,
  apiSetAtlasSuperUser
} from '../../../api/Argentia/endpoints/atlasAccess/atlasAccess.api'
import {
  AtlasAccessDetailModel,
  AtlasAccessKpiModel,
  AtlasAccessSearchFilterModel,
  AtlasAccessTableModel,
  EnumAtlasEntityType
} from '../../../api/Argentia/endpoints/atlasAccess/model/atlasAccess'
import { apiGetSubjects } from '../../../api/Argentia/endpoints/clients/clients.api'
import { AtlasUserModel } from '../../../api/Argentia/endpoints/tasks/model/tasks'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../../model/serviceResponse'
import { subjectFilterMapper, subjectsListMapper } from '../../clients/client.mapper'
import { mapAtlasUsersToSelectOptionArray } from '../../tasks/tasks.mapper'

export const searchAtlasAccess = async (
  request: AtlasAccessSearchFilterModel
): Promise<ServiceResponse<AtlasAccessTableModel[] | undefined>> => {
  return await apiSearchAtlasAccess(request)
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}

export const fetchAtlasAccessKpis = async (): Promise<
  ServiceResponse<AtlasAccessKpiModel | undefined>
> => {
  return await apiGetAtlasAccessKpis()
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}

export const fetchAtlasAccessTable = async (): Promise<
  ServiceResponse<AtlasAccessTableModel[] | undefined>
> => {
  return await apiGetAtlasAccessTable()
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}

// wrapper de subjects.service.fetchSubjects sin filtro de subjectTypeList, para traer todos los tipos de cliente
export const fetchAtlasAccessSubjects = async (query: string): Promise<SelectOption[]> => {
  const subjectTypeList: EnumTipoSujeto[] = Object.values(EnumTipoSujeto) as EnumTipoSujeto[]
  const isActive: boolean = true
  const commodity: EnumCommodity = EnumCommodity.GasNatural
  return await apiGetSubjects(
    subjectFilterMapper(query, subjectTypeList, isActive, commodity)
  ).then(response => {
    return subjectsListMapper(response)
  })
}

// wrapper de apiSearchAtlasUsers para el searchfield de usuarios/email de la pantalla de accesos
export const fetchAtlasAccessUsers = async (query: string): Promise<SelectOption[]> => {
  return await apiSearchAtlasUsers(query).then(response => {
    return mapAtlasUsersToSelectOptionArray(response ?? [])
  })
}

export const fetchClientAccessDetail = async (
  entityId: number,
  entityType: EnumAtlasEntityType
): Promise<ServiceResponse<AtlasAccessDetailModel | undefined>> => {
  return await apiGetAtlasAccessDetail({ entityId, entityType })
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}

// wrapper de apiSearchAtlasUsers sin mapear a SelectOption - se necesitan rol/estado/superuser
// crudos para deshabilitar "Añadir" en el buscador de superusuarios
export const searchAtlasUsers = async (query: string): Promise<AtlasUserModel[]> => {
  return await apiSearchAtlasUsers(query).then(response => response ?? [])
}

export const fetchAtlasSuperUsers = async (): Promise<
  ServiceResponse<AtlasUserModel[] | undefined>
> => {
  return await apiGetAtlasSuperUsers()
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}

export const addAtlasSuperUser = async (idUsuarioAtlas: number): Promise<ServiceResponse<void>> => {
  return await apiSetAtlasSuperUser(idUsuarioAtlas, true)
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}

export const removeAtlasSuperUserPermission = async (
  idUsuarioAtlas: number
): Promise<ServiceResponse<void>> => {
  return await apiSetAtlasSuperUser(idUsuarioAtlas, false)
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}

// da de baja al usuario atlas - el back también le quita el permiso de superusuario
export const deactivateAtlasUser = async (
  idUsuarioAtlas: number
): Promise<ServiceResponse<void>> => {
  return await apiDeactivateUsuarioAtlas(idUsuarioAtlas)
    .then(response => createSuccessServiceResponse(response))
    .catch(error => createErrorServiceResponse(error))
}
